var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconElectrolinera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 120,
    viewBox: "0 0 68 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.8875 28.5958H53.4287V5.10631C53.4287 2.29787 51.128 0 48.316 0C45.504 0 43.2033 2.29787 43.2033 5.10631V28.5956H24.7972V5.10631C24.7972 2.29787 22.4964 0 19.6842 0C16.872 0 14.5715 2.29787 14.5715 5.10631V28.5956H5.11272C2.30076 28.5956 0 30.8935 0 33.7019V64.0848C0 64.8508 0.255719 65.6167 0.5112 66.3827L9.71425 98.8083C10.4812 100.851 12.2707 102.383 14.5715 102.383H28.8873V114.894C28.8873 117.702 31.188 120 34 120C36.812 120 39.1127 117.702 39.1127 114.894V102.383H53.4285C55.4735 102.383 57.5188 100.851 58.2857 98.8086L67.4888 66.3829C67.7445 65.617 68 65.1064 68 64.0851V33.7021C68.0005 30.8937 65.6997 28.5958 62.8875 28.5958ZM49.5944 92.4255H18.4061L11.7595 69.1914H56.2409L49.5944 92.4255ZM58.0305 58.9788H10.2257V38.5533H58.0305V58.9788Z",
    fill: "#5D008B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconElectrolinera);
export default __webpack_public_path__ + "static/media/icon_electrolinera.9a7a8713ad7e5cc34d206c50616406a8.svg";
export { ForwardRef as ReactComponent };